import { render } from "./InlineActionButton.vue?vue&type=template&id=7dd3770e&scoped=true"
import script from "./InlineActionButton.vue?vue&type=script&lang=js"
export * from "./InlineActionButton.vue?vue&type=script&lang=js"

import "./InlineActionButton.vue?vue&type=style&index=0&id=7dd3770e&lang=scss&scoped=true"

import exportComponent from "/home/user/AIF_Orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd3770e"]])

export default __exports__